import api from "../../../../../../../api";
import utils from "../../../../../../../utils";
import values from "../../../../../../../values";
import Context from "../../../../../../../context";

import * as Yup from "yup";

import React, { useEffect, useState } from "react";

import { useQuery } from "react-query";
import { useFormik } from "formik";
import { IUpdateService } from "../../../../../../../types/service.interface";
import {
  CustomButton2,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomInput,
  CustomTimePiker,
  CustomView,
} from "../../../../../../../components";
import {
  ICompanyItem,
  IOnSearchUser,
} from "../../../../../../../types/common.interface";
import validations from "../../../../../../../validations";
import { CYCLE } from "../../../../../../../values/dropdownItems";
import { useTranslation } from "react-i18next";

const AdministratorUpdateService = () => {
  const { isLoading, setShowModal, selectedService, updateFunctionService } =
    React.useContext(Context.ServiceScreen);

  const [searchedValueParent, setSearchedValueParent] =
    React.useState<IOnSearchUser>();
  const [searchedValueSchool, setSearchedValueSchool] =
    React.useState<IOnSearchUser>();
  const [searchedValueCompany, setSearchedValueCompany] =
    React.useState<IOnSearchUser>();
  const [searchedValueDriver, setSearchedValueDriver] =
    React.useState<IOnSearchUser>();
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    company: "",
    parent: "",
    driver: "",
    school: "",
    expire: "",
    cycle: "",
  });
  const [selectedCycle, setSelectedCycle] = React.useState<any>(
    selectedService?.cycle
  );

  const getAllParent = useQuery(
    [values.useQueryKeys.getAllParent, searchedValueParent],
    () =>
      api.post.administrator.getAllParent({
        search: {
          base: searchedValueParent?.base?.value,
          value: searchedValueParent?.searchedValue,
        },
      })
  );

  const getAllCompany = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValueCompany?.searchedValue],
    () =>
      api.post.administrator.getAllCompany({
        search: {
          base: searchedValueCompany?.base?.value,
          value: searchedValueCompany?.searchedValue,
        },
      })
  );

  const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      companyName: item?.companyInformation?.companyName,
    })
  );

  const [selectedCompany, setSelectedCompany] = useState<any>(
    companyInformationWithCompanyName?.find(
      (item: any) => item?._id === selectedService?.company?._id
    )
  );

  const getAllDriver = useQuery(
    [
      values.useQueryKeys.getAllDriver,
      selectedCompany?._id,
      searchedValueDriver?.searchedValue,
    ],
    () =>
      api.post.common.findDriver({
        companyId: selectedCompany?._id,
        search: {
          base: searchedValueDriver?.base.value,
          value: searchedValueDriver?.searchedValue,
        },
      })
  );

  // ** ===========================================================================================================
  // **                                            Values Validation
  // ** -----------------------------------------------------------------------------------------------------------

  const AllParentWithCompleteName = getAllParent?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );
  const AllDriverWithCompleteName = getAllDriver?.data?.result?.map(
    (item: any) => {
      return {
        ...item,
        completeName: item.firstName + " " + item.lastName,
      };
    }
  );

  const [expireDate, setExpireDate] = useState<string>("");
  const [selectedParent, setSelectedParen] = useState<any>(
    AllParentWithCompleteName?.find(
      (item: any) => item?._id === selectedService?.parent?._id
    )
  );
  const [selectedDriver, setSelectedDriver] = useState<any>(
    AllDriverWithCompleteName?.find(
      (item: any) => item?._id === selectedService?.driver?._id
    )
  );
  const [selectedSchool, setSelectedSchool] = useState<any>(
    selectedService?.school
  );

  // !! ===========================================================================================================
  // !!                                              REST API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllSchool = useQuery(
    [values.useQueryKeys.getAllSchool, searchedValueSchool?.searchedValue],
    () =>
      api.post.common.findSchoolPost({
        search: {
          base: searchedValueSchool?.base?.value,
          value: searchedValueSchool?.searchedValue,
        },
      })
  );

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------
  const formik = useFormik<IUpdateService>({
    initialValues: {
      price: selectedService?.price,
      expire: selectedService?.expire,
    },
    validationSchema: Yup.object({
      price: validations.yupValidations.price,
    }),
    onSubmit: (values: IUpdateService, { setSubmitting }) => {
      const formValues: IUpdateService = {
        ...values,
        price: utils.convertPriceToNumber(values?.price as string).toString(),
        expire: utils.convertNumbers2English(expireDate),
        school: selectedSchool,
        parent: selectedParent,
        driver: selectedDriver,
        company: selectedCompany,
        serviceId: selectedService?._id,
        student: selectedService?.student,
        cycle: selectedCycle?.value,
      };
      if (
        selectedCompany &&
        selectedDriver &&
        selectedParent &&
        selectedSchool &&
        expireDate &&
        selectedCycle
      ) {
        Promise.resolve(updateFunctionService!(formValues)).catch(() =>
          setSubmitting(false)
        );
      }
    },
  });
  const { t } = useTranslation();

  const submitHandler = () => {
    let dropDownErrorsList = {
      company: "",
      school: "",
      driver: "",
      parent: "",
      expire: "",
      cycle: "",
    };
    if (!selectedCompany) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        company: t("company_is_required"),
      };
    }
    if (!selectedSchool) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        school: t("school_is_required"),
      };
    }
    if (!selectedDriver) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        driver: t("driver_is_required"),
      };
    }
    if (!selectedParent) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        parent: t("parent_is_required"),
      };
    }
    if (!expireDate) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        expire: t("expire_is_required"),
      };
    }
    if (!selectedCycle) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        cycle: t("cycle_is_required"),
      };
    }

    setDropDownErrors(dropDownErrorsList);

    formik.submitForm();
  };

  useEffect(() => {
    setSelectedCompany(
      companyInformationWithCompanyName?.find(
        (item: any) => item?._id === selectedService?.company?._id
      )
    );
  }, [companyInformationWithCompanyName?.length]);

  useEffect(() => {
    setSelectedCycle(
      CYCLE.find((item) => item.value === selectedService?.cycle)
    );
  }, [selectedService]);
  useEffect(() => {
    setSelectedDriver(
      AllDriverWithCompleteName?.find(
        (item: any) => item?._id === selectedService?.driver?._id
      )
    );
  }, [AllDriverWithCompleteName?.length]);
  useEffect(() => {
    setSelectedParen(
      AllParentWithCompleteName?.find(
        (item: any) => item?._id === selectedService?.parent?._id
      )
    );
  }, [AllParentWithCompleteName?.length]);

  useEffect(() => {
    setExpireDate(selectedService?.expire);
  }, [selectedService]);

  return (
    <CustomView.Container id="service-update-form-content">
      <CustomView.Row className="form-row">
        <CustomView.Column className="form-colum">
          <label className="form-label">{t("servicePrice")}</label>
          <CustomInput
            name="price"
            id="price"
            value={
              utils.convertPriceToNumber(formik.values.price as string)
                ? utils.convertNumberToPrice(
                    utils.convertPriceToNumber(formik.values.price as string)
                  )
                : "0"
            }
            onValueChange={formik.handleChange}
            formikProps={{ onBlur: formik.handleBlur }}
            error={formik.errors.price && formik.touched.price}
            errorText={formik.errors.price}
          />
        </CustomView.Column>
        <CustomView.Column className="form-colum dropdown">
          <label className="form-label">{t("serviceStartDate")}</label>
          <CustomTimePiker
            defaultValue={expireDate}
            onChange={(event) => setExpireDate(event)}
          />
          <div className="error">
            {dropDownErrors.expire !== "" && dropDownErrors.expire}
          </div>
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row">
        <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">{t("company")}</label>
          <CustomDropdownMultiSearch
            isSearch
            baseSearch={values.dropdownBaseSearch.COMPANY_BASE_SEARCH.map(
              (item) => ({
                ...item,
                title: t(item.title),
              })
            )}
            items={companyInformationWithCompanyName}
            itemName="companyName"
            onSelectItem={(event: ICompanyItem) => {
              setSelectedCompany(event);
              setDropDownErrors({ ...dropDownErrors, company: "" });
            }}
            defaultItem={selectedCompany}
            searchedValue={searchedValueCompany}
            setSearchedValue={setSearchedValueCompany}
            placeHolder={t("selectCompany")}
            isLoading={getAllCompany.isLoading}
            selectedBaseSearch={
              searchedValueCompany?.base?.value === "nationalCode"
                ? "companyInformation.nationalCode"
                : searchedValueCompany?.base?.value
            }
          />
          <div className="error">
            {dropDownErrors.company !== "" && dropDownErrors.company}
          </div>
        </CustomView.Column>

        <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">{t("driver")}</label>

          <CustomDropdownMultiSearch
            isSearch
            baseSearch={values.dropdownBaseSearch.DRIVER_BASE_SEARCH.map(
              (item) => ({
                ...item,
                title: t(item.title),
              })
            )}
            items={AllDriverWithCompleteName}
            itemName="completeName"
            onSelectItem={(event: ICompanyItem) => {
              setSelectedDriver(event);
              setDropDownErrors({ ...dropDownErrors, driver: "" });
            }}
            defaultItem={selectedDriver}
            searchedValue={searchedValueDriver}
            setSearchedValue={setSearchedValueDriver}
            placeHolder={t("selectDriver")}
            isLoading={getAllDriver.isLoading}
            selectedBaseSearch={searchedValueDriver?.base?.value}
          />
          <div className="error">
            {dropDownErrors.driver !== "" && dropDownErrors.driver}
          </div>
        </CustomView.Column>
      </CustomView.Row>
      <CustomView.Row className="form-row final-row">
        <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">{t("school")}</label>
          <CustomDropdownMultiSearch
            isSearch
            baseSearch={values.dropdownBaseSearch.SCHOOL_BASE_SEARCH.map(
              (item) => ({
                ...item,
                title: t(item.title),
              })
            )}
            items={getAllSchool?.data?.result}
            itemName="name"
            onSelectItem={(event: ICompanyItem) => {
              setSelectedSchool(event);
              setDropDownErrors({ ...dropDownErrors, school: "" });
            }}
            defaultItem={selectedSchool}
            searchedValue={searchedValueSchool}
            setSearchedValue={setSearchedValueSchool}
            placeHolder={t("selectSchool")}
            isLoading={getAllSchool.isLoading}
            selectedBaseSearch={searchedValueSchool?.base?.value}
          />
          <div className="error">
            {dropDownErrors.school !== "" && dropDownErrors.school}
          </div>
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">{t("parent")}</label>
          <CustomDropdownMultiSearch
            isSearch
            baseSearch={values.dropdownBaseSearch.PARENT_BASE_SEARCH.map(
              (item) => ({
                ...item,
                title: t(item.title),
              })
            )}
            items={AllParentWithCompleteName}
            itemName="completeName"
            onSelectItem={(event: ICompanyItem) => {
              setSelectedParen(event);
              setDropDownErrors({ ...dropDownErrors, parent: "" });
            }}
            defaultItem={selectedParent}
            searchedValue={searchedValueParent}
            setSearchedValue={setSearchedValueParent}
            placeHolder={t("selectParent")}
            isLoading={getAllParent.isLoading}
            selectedBaseSearch={searchedValueParent?.base?.value}
          />
          <div className="error">
            {dropDownErrors.parent !== "" && dropDownErrors.parent}
          </div>
        </CustomView.Column>
        <CustomView.Column medium={6} className="form-colum dropdown">
          <label className="form-label">{t("cycle")}</label>
          <CustomDropdownSearch
            items={CYCLE}
            itemName="name"
            defaultItem={selectedCycle}
            onSelectItem={(event: any) => {
              setSelectedCycle(event);
              setDropDownErrors({ ...dropDownErrors, cycle: "" });
            }}
            placeHolder={t("selectCycle")}
          />
          <div className="error">
            {dropDownErrors.cycle !== "" && dropDownErrors.cycle}
          </div>
        </CustomView.Column>
      </CustomView.Row>
      <hr />
      <CustomView.Row className="form-row">
        <CustomView.Column
          medium={6}
          className="form-colum submit-button-relation"
        >
          <CustomButton2
            isLoading={isLoading}
            onClick={() => setShowModal!("NONE")}
            title={t("cancel")}
            type="danger"
          />
        </CustomView.Column>
        <CustomView.Column
          medium={6}
          className="form-colum submit-button-relation"
        >
          <CustomButton2
            isLoading={isLoading}
            onClick={submitHandler}
            title={t("submit")}
          />
        </CustomView.Column>
      </CustomView.Row>
    </CustomView.Container>
  );
};

export default AdministratorUpdateService;
